import type { RfiAsk } from '@/api/types';

/**
 * DETERMINISTIC client-side RFI template assembly (F-IS-04). No AI drafting: the subject/body are a
 * pure function of the asks, assembled here and shown to the analyst to edit before the send gate.
 * The exact text the analyst sees is the exact text that is sent.
 */

/** Asks that carry content (an evidence kind or a note). */
export function realAsks(asks: RfiAsk[]): RfiAsk[] {
  return asks.filter((a) => a.evidenceKind.trim() !== '' || a.note.trim() !== '');
}

export function defaultSubject(asks: RfiAsk[]): string {
  const n = realAsks(asks).length;
  return `Request for information — ${n} item${n === 1 ? '' : 's'} outstanding`;
}

export function assembleBody(asks: RfiAsk[]): string {
  const lines: string[] = [];
  lines.push('Dear Sir or Madam,');
  lines.push('');
  lines.push('To continue our review we need the following before we can proceed:');
  lines.push('');
  const items = realAsks(asks);
  if (items.length === 0) {
    lines.push('1. [add at least one ask above to populate this list]');
  } else {
    items.forEach((a, i) => {
      const head = a.evidenceKind.trim() || 'Requested item';
      const note = a.note.trim() ? ` — ${a.note.trim()}` : '';
      lines.push(`${i + 1}. ${head}${note}`);
      if (a.precision && a.precision.trim()) {
        lines.push(`   (${a.precision.trim()})`);
      }
    });
  }
  lines.push('');
  lines.push(
    'Please reply to this message with the requested documents. If anything is unclear, let us know and we will help.',
  );
  lines.push('');
  lines.push('Kind regards,');
  lines.push('Compliance Operations');
  return lines.join('\n');
}
